import { Component, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-tracking-map-only',
    templateUrl: './map-only.component.html',
    styleUrls: ['./map-only.component.css'],
    standalone: false
})
export class TrackingMapOnlyComponent implements AfterViewInit
{
  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "TrackingMapOnly" }));
  }
}
